<template>
    <!-- Echanges avec le citoyen -->
    <section aria-labelledby="repondre-title">
        <div class="bg-white shadow sm:rounded-lg sm:overflow-hidden">
            <div class="divide-y divide-gray-200">
                <div class="px-4 py-5 sm:px-6">
                    <h2
                        id="repondre-title"
                        class="text-lg font-medium text-secondaryColor"
                    >
                        {{ $t('post.page.messages.exchange') }}
                    </h2>
                </div>
                <div>
                    <div
                        v-if="post.messages && post.messages.length > 0"
                        id="messages"
                        class="flex flex-col space-y-4 p-3"
                    >
                        <div
                            v-for="message in post.messages"
                            :key="message.id"
                            class="chat-message"
                        >
                            <!-- message citoyen -->

                            <div
                                class="flex items-end justify-end"
                                v-if="message.author_type === 2"
                            >
                                <div
                                    class="flex flex-col space-y-2 w-11/12 mx-2 order-1 items-end"
                                >
                                    <p class="text-xs text-gray-400 italic">
                                        <time :datetime="message.created_at">
                                            {{
                                                moment(message.created_at)
                                                    .locale($store.state.lang)
                                                    .format('LLL')
                                            }}
                                        </time>
                                    </p>
                                    <div
                                        v-if="message.content"
                                        class="w-full px-4 py-2 rounded-lg inline-block rounded-br-none bg-themeColor text-white"
                                    >
                                        <span
                                            class="message break-words"
                                            v-if="message.content.message"
                                            v-html="
                                                displayHtml(
                                                    message.content.message,
                                                    true
                                                )
                                            "
                                            style="white-space: pre-line"
                                        ></span>
                                        <span v-if="message.content.files">
                                            <span
                                                v-for="(file, index) in message
                                                    .content.files"
                                                :key="index"
                                                class="flex align-items-center"
                                            >
                                                <IconPaperClip
                                                    class="flex-shrink-0 h-5 w-5"
                                                />
                                                <a
                                                    :href="file.url"
                                                    :download="file.name"
                                                    class="pl-2 text-black"
                                                    style="color: black"
                                                >
                                                    <p>
                                                        {{ file.name }}
                                                    </p></a
                                                >
                                            </span>
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <!-- message gestionnaire -->

                            <div
                                class="flex flex-col space-y-2 w-11/12 mx-2 order-1 items-start"
                                v-if="message.author_type === 1"
                            >
                                <div class="flex-shrink-0">
                                    <p class="text-xs text-gray-400 italic">
                                        <time :datetime="message.created_at">
                                            {{
                                                moment(message.created_at)
                                                    .locale($store.state.lang)
                                                    .format('LLL')
                                            }}
                                        </time>
                                    </p>
                                </div>
                                <div
                                    v-if="message.content"
                                    class="w-full px-4 py-2 rounded-lg inline-block rounded-bl-none bg-gray-100"
                                >
                                    <span
                                        v-if="message.content.message"
                                        v-html="
                                            displayHtml(
                                                message.content.message,
                                                true
                                            )
                                        "
                                        class="message text-gray-900 break-words"
                                        style="white-space: pre-line"
                                    ></span>
                                    <span v-if="message.content.files"> </span>
                                    <span
                                        v-for="(file, index) in message.content
                                            .files"
                                        :key="index"
                                        class="text-black flex align-items-center"
                                        style="color: black"
                                    >
                                        <IconPaperClip
                                            class="flex-shrink-0 h-5 w-5"
                                        />
                                        <a
                                            :href="file.url"
                                            :download="file.name"
                                            class="pl-2 text-black"
                                            style="color: black"
                                        >
                                            <p>
                                                {{ file.name }}
                                            </p></a
                                        >
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- si pas de message  -->
                    <div v-else class="bg-yellow-50 p-4 sm:rounded-lg">
                        <div class="flex">
                            <div class="flex-shrink-0">
                                <IconWarning class="h-5 w-5 text-yellow-400" />
                            </div>
                            <div class="ml-3">
                                <p class="text-sm text-yellow-700">
                                    {{ $t('post.page.messages.no_exchange') }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- formulaire de réponse -->
            <div
                class="bg-gray-50 px-4 py-4 sm:px-6 animate__animated animate__faster animate__zoomIn"
            >
                <div class="min-w-0">
                    <div
                        id="ckComments"
                        class="panel-content p-0 border-bottom border-top border-faded"
                    >
                        <ckeditor
                            v-model="content"
                            class="shadow-sm block w-full focus:ring-blue-500 focus:border-blue-500 sm:text-sm border border-gray-300 rounded-md"
                            :config="editorConfig"
                            :editor="editor"
                        >
                        </ckeditor>
                    </div>
                    <div class="mt-3 flex items-center justify-between">
                        <button
                            id="postComment"
                            :disabled="isDisabled"
                            :class="isDisabled ? 'cursor-not-allowed' : ''"
                            v-if="!loading"
                            class="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-themeColor hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                            type="button"
                            @click.prevent="postComment"
                        >
                            {{ $t('post.page.messages.send') }}
                        </button>

                        <button
                            v-else
                            class="inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-themeColor hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                            disabled="disabled"
                        >
                            <span
                                aria-hidden="true"
                                class="spinner-border spinner-border-sm"
                                role="status"
                            ></span>
                            {{ $t('post.page.messages.process') }}
                        </button>
                        <b-field class="file" v-if="!loading">
                            <b-upload
                                id="uploadFiles"
                                multiple
                                drag-drop
                                @input="showFiles"
                                v-model="dropFiles"
                                class="file-label"
                            >
                                <span
                                    class="file- cta inline-flex items-center justify-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-themeColor hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                                >
                                    <IconPaperClip
                                        class="flex-shrink-0 h-5 w-5 text-white"
                                    />
                                </span>
                                <span
                                    class="file-name inline-flex justify-center px-4 py-2 text-sm"
                                    v-if="filesList.length > 0"
                                >
                                    {{ filesList.length }}
                                </span>
                            </b-upload>
                        </b-field>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<style>
.message ul li,
.message ul {
    list-style-type: disc !important;
}

.message ol li,
.message ol {
    list-style-type: number !important;
}

.message ul,
.message ol {
    padding-left: 15px !important;
}

@media only screen and (min-width: 768px) and (max-width: 1280px) {
    .long-url {
        max-width: 20em !important;
        width: 20em !important;
    }
}

@media only screen and (min-width: 1280px) {
    .long-url {
        max-width: 40rem !important;
        width: 40rem !important;
    }
}

.long-url {
    display: block !important;
    max-width: 16rem;
    width: 16rem;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
</style>
<style scoped>
#ckComments .ck.ck-toolbar {
    border: none;
    border-bottom: 1px solid #dee2e6 !important;
}

#ckComments .ck.ck-editor__main > .ck-editor__editable {
    border: none;
    padding: 1em 2em 1em 2em;
}

::v-deep .citizen {
    color: white;
}

::v-deep .administrator {
    color: black;
}

::v-deep .upload .upload-draggable {
    padding: 0px;
    padding-right: 3px;
    border: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

<script>
import { mapActions } from 'vuex'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import IconUserPlain from '@/components/icons/iconUserPlain.vue'
import IconPaperClip from '@/components/icons/iconPaperClip.vue'
import IconWarning from '@/components/icons/iconWarning.vue'

export default {
    name: 'PostMessages',
    props: ['post', 'isConnected'],
    components: { IconUserPlain, IconPaperClip, IconWarning },
    computed: {
        isDisabled() {
            if (
                (this.content != null && this.content != '') ||
                (this.filesList != [] && this.filesList.length > 0)
            ) {
                return false
            }
            return true
        }
    },
    data() {
        return {
            isMessage: true,
            content: null,
            postMessage: {},
            loading: false,
            editor: ClassicEditor,
            editorConfig: {
                toolbar: {
                    items: [
                        'bold',
                        'italic',
                        'link',
                        '|',
                        'bulletedList',
                        'numberedList',
                        '|',
                        'undo',
                        'redo',
                        '|'
                    ]
                }
            },
            filesList: [],
            dropFiles: []
        }
    },
    mounted() {
        const liens = this.$el.querySelectorAll('.chat-message a')
        liens.forEach((list) => {
            if (list.getAttribute('href').length > 20) {
                list.classList.add('long-url')
            }
        })
    },
    methods: {
        ...mapActions('post', ['sendNewMessage']),
        onEditorReady(editor) {
            this.uploader(editor)
        },
        uploader(editor) {
            var token = window.localStorage.getItem('token')
            var baseURL = window.localStorage.getItem('baseURL')

            editor.plugins.get('FileRepository').createUploadAdapter = (
                loader
            ) => {
                return new UploadAdapter(loader, token, baseURL)
            }
        },
        displayHtml(message, isText = false) {
            message = message
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&amp;/g, '&')
            if (!isText) message = message.replace(/<br\s*[/]?>/gi, '')
            return message
        },
        postComment() {
            this.loading = true
            this.postMessage.post_id = this.post.id
            if (this.filesList.length == 0) {
                this.postMessage.content = { message: this.content }
            } else if (this.filesList.length > 0 && this.content == null) {
                this.postMessage.content = { files: this.filesList }
            } else {
                this.postMessage.content = {
                    message: this.content,
                    files: this.filesList
                }
            }
            this.sendMessage(this.postMessage)
            this.filesList = []
            this.dropFiles = []
        },
        showFiles(dropFiles) {
            dropFiles.forEach((file) => {
                if (file['size'] > 6250000) {
                    this.$buefy.toast.open({
                        duration: 5000,
                        message: this.$t('error.validation.file_size_max'),
                        type: 'is-danger'
                    })
                    dropFiles = []
                    return
                } else {
                    this.encodeFileToBase64(file)
                }
            })
        },
        encodeFileToBase64(file) {
            this.filesList = []
            var fr = new FileReader()
            fr.onload = (e) => {
                this.filesList.push({
                    name: file.name,
                    encodedFile: e.target.result
                })
            }
            fr.readAsDataURL(file)
        },
        sendMessage(content) {
            this.sendNewMessage(content)
                .then((response) => {
                    this.post.messages.push(response.data.message)
                    this.content = ''
                    this.$store.dispatch('toast', {
                        type: 'success',
                        title: 'Sauvegarde effectuée'
                    })
                })
                .catch((error) => {
                    this.$store.dispatch('toastError', error)
                })
                .finally(() => {
                    this.loading = false
                })
        }
    }
}
</script>
